import { render } from "./g-data-table.vue?vue&type=template&id=253e8092&scoped=true"
import script from "./g-data-table.vue?vue&type=script&lang=js"
export * from "./g-data-table.vue?vue&type=script&lang=js"

import "./g-data-table.vue?vue&type=style&index=0&id=253e8092&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253e8092"]])

export default __exports__